import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/app-config.service';
import { DivisionsBySectionValue } from '@app/features/division/models/division.interface';
import { Section, SectionDto, SectionValue } from '@app/features/division/models/section.interface';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SectionService {
  protected divisionsBySectionValue: DivisionsBySectionValue = {};

  constructor(protected http: HttpClient, private appConfigService: AppConfigService) {}

  getNew(): Observable<Section> {
    return of({
      id: null,
      name: '',
      tx: '',
      level: 0,
      values: []
    });
  }

  getById(id: string): Observable<Section> {
    return this.http.get<Section>(`${this.appConfigService.getApi()}/sections/${id}`);
  }

  getNumberOfDivisions(value: SectionValue, active: boolean): number {
    return this.divisionsBySectionValue[value.id]
      ? this.divisionsBySectionValue[value.id]
          .map(division => ((active && division.active) || (!active && !division.active) ? 1 : 0))
          .reduce((prev, current) => prev + current, 0)
      : 0;
  }

  setDivisionsBySectionValue(dbsv: DivisionsBySectionValue) {
    this.divisionsBySectionValue = dbsv;
  }

  saveNew(section: SectionDto): Observable<string> {
    return this.http.post<string>(`${this.appConfigService.getApi()}/sections`, section);
  }

  save(section: Section): Observable<Section> {
    return section.id === null ? this.create(section) : this.update(section.id, section);
  }

  update(id: string, section: Section): Observable<Section> {
    return this.http.put<Section>(`${this.appConfigService.getApi()}/sections/${id}`, section);
  }

  create(section: Section): Observable<Section> {
    return this.http.post<Section>(`${this.appConfigService.getApi()}/sections`, section);
  }

  getAll(): Observable<Section[]> {
    return this.http.get<Section[]>(`${this.appConfigService.getApi()}/sections/all`);
  }

  getAllWithoutPageable(): Observable<Section[]> {
    return this.http.get<Section[]>(`${this.appConfigService.getApi()}/sections/all`);
  }

  /**
   * Set the order of Sections
   * @param idsOrder An ids array of Sections
   */
  setSectionOrders(idsOrder: string[]): Observable<void> {
    return this.http.post<void>(`${this.appConfigService.getApi()}/sections/order`, { ids: idsOrder });
  }

  getHeaderCellName(name: string, sections: Section[]): string {
    let keyValue = '';
    if (name === 'description') {
      keyValue = 'core.general.description';
    } else if (name === 'active') {
      keyValue = 'core.status.title';
    } else if (name === 'code') {
      keyValue = 'core.general.code';
    } else {
      keyValue = sections.find(section => section.id === name).name;
    }
    return keyValue;
  }
}
